// extracted by mini-css-extract-plugin
export default {"box":"detail_box__lELNi","subTitle":"detail_subTitle__sUGyO","flexBox":"detail_flexBox__4F7e8","fix":"detail_fix__NAYvj"};